import React, { Component } from 'react'
import { Layout, Menu } from 'antd'
import { Link } from 'react-router-dom'

import { ADMIN_MENU, matchMenuGroupKey, matchMenuPath } from './adminMenu'

const { Content, Sider } = Layout

/**
 * 后台布局（侧栏 + 内容区）。
 * <p>
 * 侧栏菜单与「当前高亮」都派生自 `src/adminMenu.js` 这一份配置（key = 路由路径，高亮 = 最长前缀匹配），
 * 本组件不再手写 key 数字或 `url.indexOf(...)` 判断——那两份硬编码曾导致「重复 key 不高亮」与
 * 「短路径抢走长路径（`/admin/dsd_store_config` 高亮成 PIC签证）」。
 */
class AdminContainer extends Component {
  constructor(props) {
    super(props)
    const href = window.location.href
    this.state = {
      collapsed: false,
      mode: 'inline',
      current: matchMenuPath(href),
      // 深链接进来时自动展开所属分组，否则高亮项藏在收起的 SubMenu 里看不见
      openKey: matchMenuGroupKey(href),
    }
  }

  toggleCollapsed = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    })
  }

  renderMenuItem = (item) => (
    <Menu.Item key={item.path} onClick={() => this.setState({ current: item.path })}>
      <Link to={item.path}>{item.title}</Link>
    </Menu.Item>
  )

  render() {
    const { children } = this.props
    return (
      <Layout hasSider style={{ height: '100%', position: 'absolute', left: 0, top: 0, right: 0, bottom: 0 }}>
        <Sider
          collapsed={this.state.collapsed}
          style={{
            overflow: 'auto',
            height: '100vh',
            background: '#fff',
          }}
          onCollapse={this.toggleCollapsed}
        >
          <div style={{ textAlign: 'center' }} id="logo">
            <img src={require('./assets/images/common/PADI-logo.png')} style={{ width: '60%' }} alt="logo" />
          </div>
          <Menu
            mode={this.state.mode}
            selectedKeys={[this.state.current]}
            defaultOpenKeys={this.state.openKey ? [this.state.openKey] : []}
            inlineCollapsed={this.state.collapsed}
          >
            {ADMIN_MENU.map((entry) =>
              entry.children ? (
                <Menu.SubMenu key={entry.key} title={entry.title}>
                  {entry.children.map((item) => this.renderMenuItem(item))}
                </Menu.SubMenu>
              ) : (
                this.renderMenuItem(entry)
              )
            )}
          </Menu>
        </Sider>
        <Layout>
          <Content>{children}</Content>
        </Layout>
      </Layout>
    )
  }
}

export default AdminContainer
